/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string TypedRequestCard shows by default. A string marked CANDIDATE is new copy. An
 * unmarked string is reused as built (Continue, from the entity type selector; Draft, from the
 * identity status words; Grant now, from the permission screen's button). The caller can replace
 * any of them through the `copy` prop.
 */
import { CONTINUE_LABEL } from '../../EntityTypeSelector/EntityTypeSelector/entityTypeSelectorCopy';
import { REQUEST_IDENTITY_CARD_COPY } from '../RequestIdentityCard/requestIdentityCardCopy';

export type TypedRequestCardCopy = {
  /** The words before what a typed request asks for. */
  asksFor: string;
  /** The primary button on a typed request with no draft. */
  start: string;
  /** The primary button on a typed request with a draft in progress. */
  continue: string;
  /** The text button on a Legacy request. The button style draws it in capitals. */
  grantNow: string;
  /** The chip beside the in-progress line. */
  draft: string;
  /** The line after the Draft chip. */
  draftInProgress: string;
  /** The name of the menu button, for a screen reader. It names the provider, as a page holds many cards. */
  menuLabel: (providerName: string) => string;
};

export const TYPED_REQUEST_CARD_COPY: TypedRequestCardCopy = {
  // CANDIDATE COPY, not approved (verifime-adr#617)
  asksFor: 'asks for',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  start: 'Start',
  // As built: the entity type selector's Continue.
  continue: CONTINUE_LABEL,
  // As built: the permission screen's "Grant now" button (SubmittedIdentity), drawn in capitals.
  grantNow: 'Grant now',
  // As built: the identity status word Draft.
  draft: REQUEST_IDENTITY_CARD_COPY.draft,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  draftInProgress: 'in progress for this request',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  menuLabel: (providerName) => `Options for the request from ${providerName}`,
};

/**
 * The label of the Dismiss menu item. The parent builds the menu items, so the card does not read
 * this: it is the default for a parent or a story to use.
 */
// CANDIDATE COPY, not approved (verifime-adr#617)
export const DISMISS_MENU_ITEM_LABEL = 'Dismiss';

/** Overrides for the default copy. Any string may be left out. A string set to `undefined` counts as left out. */
export type TypedRequestCardCopyOverrides = Partial<TypedRequestCardCopy>;

/** The default copy with the caller's overrides laid over it, one string at a time. */
export function resolveTypedRequestCardCopy(
  overrides: TypedRequestCardCopyOverrides = {},
): TypedRequestCardCopy {
  const given = Object.fromEntries(
    Object.entries(overrides).filter(([, text]) => text !== undefined),
  );
  return { ...TYPED_REQUEST_CARD_COPY, ...given };
}
